import { MoreHorizontal, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'

interface ChatActionsProps {
  chatId: string
  onDelete: (chatId: string) => void
}

export function ChatActions({ chatId, onDelete }: ChatActionsProps) {
  const { t } = useTranslation()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant='ghost'
          size='icon'
          className='h-8'
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal />
          <span className='sr-only'>Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onClick={() => onDelete(chatId)}
          className='text-destructive'
        >
          <Trash2 className='mr-2 h-4 w-4' />
          {t(tokens.ui.common.delete)}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}